import { TOUR_CUSTOMER_LOCATION_SUCCESS } from "Constant";
const initialState = {
  start_location: "",
  end_location: "",
  month: "",
  year: "",
};

export default function locationReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case TOUR_CUSTOMER_LOCATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
